<template>
  <div>
    <div id="main-wrapper">
      <Header v-if="isLaptop" />

      <AppMain />
    </div>
  </div>
</template>

<script>
import Header from "@/components/fixedcomponents/header.vue";

import AppMain from "@/components/Layout/AppMain";

export default {
  name: "Layout",

  components: {
    Header,
    AppMain,
  },

  data() {
    return {
      isLaptop: true,
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
  },
};
</script>
